export default () => 'IDP login in progress';
